import React, { Component } from 'react';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import { nest } from 'd3-collection';
import GoogleTagManager from '@ta-interaktiv/react-gtm';
import browsercheck from '@ta-interaktiv/browsercheck';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var LOADING = 'loading';
var ERROR = 'error';
var READY = 'ready';
var Tracking = (function (_super) {
    __extends(Tracking, _super);
    function Tracking() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadTimestamp = Date.now();
        _this.state = {
            loadingState: LOADING,
            gtmArticleData: []
        };
        return _this;
    }
    Tracking.prototype.render = function () {
        var _this = this;
        if (this.state.loadingState === LOADING ||
            this.state.loadingState === ERROR) {
            return null;
        }
        if (this.state.loadingState === READY && this.state.gtmId) {
            return (React.createElement("div", { className: 'tracking' }, this.state.gtmArticleData.map(function (tracker, index) {
                return (React.createElement(GoogleTagManager, { gtmId: _this.state.gtmId, gtmTrackingConfig: tracker, key: index }));
            })));
        }
    };
    Tracking.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.gtmId && this.props.statisticsConfigs) {
            this.setupTracking(this.props.statisticsConfigs, this.props.gtmId);
            return;
        }
        var hostdomain = parseHostname().publicationDomain;
        if (hostdomain === 'localhost') {
            hostdomain = 'tagesanzeiger.ch';
        }
        var articleIdFragment = '';
        if (this.props.articleId) {
            articleIdFragment += "/articles/" + this.props.articleId;
        }
        return fetch("https://m." + hostdomain + "/api" + articleIdFragment + "/external_services")
            .then(function (response) {
            return response.json().then(function (data) {
                _this.setupTracking(data.statistics, data.configs.gtm_id);
                return data;
            });
        })
            .catch(function (error) {
            console.group('Polymorphic Tracking');
            console.warn('Data could not be loaded from the Newsnet API.');
            console.log(error.messaging, error);
            console.groupEnd();
            _this.setState({
                loadingState: ERROR
            });
        });
    };
    Tracking.prototype.setupTracking = function (statisticsConfig, gtmId) {
        var _this = this;
        var nestedTrackers = nest()
            .key(function (d) { return d.provider; })
            .map(statisticsConfig);
        if (this.props.articleId && nestedTrackers.has('wemf')) {
            nestedTrackers.get('wemf').map(function (tracker) {
                var baseTrackerUrl = Tracking.getTrackingUrl(tracker);
                var completeUrl = baseTrackerUrl + "?r=" + encodeURIComponent(document.referrer) + "&d=" + _this.loadTimestamp;
                Tracking.trackWithImage(completeUrl);
            });
        }
        this.setState({
            loadingState: READY,
            gtmArticleData: nestedTrackers.get('gtm') || [
                {
                    type: 'gtm',
                    provider: 'gtm',
                    pagetype: 'embedded content',
                    category: 'interactive'
                }
            ],
            gtmId: gtmId
        });
    };
    Tracking.trackWithImage = function (src) {
        var image = new Image();
        image.src = src;
    };
    Tracking.getTrackingUrl = function (trackerUrlOptions) {
        if (browsercheck.isAndroidApp) {
            return trackerUrlOptions.android_url;
        }
        if (browsercheck.isIOSNativeApp) {
            return trackerUrlOptions.iphone_url;
        }
        if (browsercheck.isIOSNativeTabletApp) {
            return trackerUrlOptions.ipad_url;
        }
        if (browsercheck.isDesktop) {
            return trackerUrlOptions.desktop_url;
        }
        if (browsercheck.isMobile) {
            return trackerUrlOptions.webapp_url;
        }
        return trackerUrlOptions.url;
    };
    return Tracking;
}(Component));

export default Tracking;
export { Tracking };
//# sourceMappingURL=index.js.map
